function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M14,30a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56,27.83v8.34H8V27.83H56m0-4H8a4,4,0,0,0-4,4v8.34a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V27.83a4,4,0,0,0-4-4Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M14,10.09a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56,8V16.3H8V8H56m0-4H8A4,4,0,0,0,4,8V16.3a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V8a4,4,0,0,0-4-4Z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M14,50a2,2,0,1,0,2,2,2,2,0,0,0-2-2Z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M56,47.7V56H8V47.7H56m0-4H8a4,4,0,0,0-4,4V56a4,4,0,0,0,4,4H56a4,4,0,0,0,4-4V47.7a4,4,0,0,0-4-4Z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M51.87,12.88H20.12a.75.75,0,0,1,0-1.5H51.87a.75.75,0,0,1,0,1.5Z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M51.87,32.75H20.12a.75.75,0,0,1,0-1.5H51.87a.75.75,0,1,1,0,1.5Z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M51.87,52.79H20.12a.75.75,0,1,1,0-1.5H51.87a.75.75,0,0,1,0,1.5Z"
});

var SvgDatabase = function SvgDatabase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDatabase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Database.46c5373c.svg";
export { ForwardRef as ReactComponent };